// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e66e8330","703":"bea24f3b"}[chunkId] + ".chunk.js";
};